import { apiClient } from '@api/apiClient';
import { Button, CircularProgress } from '@atgfr8/atg-ui-tailwind';
import { ToastType } from '@components/Toast';
import { closeModal } from '@store/modals/store';
import { TabState } from '@store/orders';
import { setActiveCarrierTab } from '@store/orders/actions/carrierActions';
import {
  orderStore,
  setLoadSureStore,
  setOrderStore,
} from '@store/orders/store';
import { handleToast } from '@utils/utils';
import { createSignal } from 'solid-js';
import { produce } from 'solid-js/store';
import { buildChangeTrackingRequestConfig } from '@changeTracking/utils/buildChangeTrackingHeaders';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';

import {
  cancelInsuranceModal,
  cancelReasons,
  loadId,
  loadSureVendorContractId,
} from './LoadSureHelpers';
import { LoadSureSelect } from './LoadSureSelect';

export const CancelInsuranceModal = () => {
  const [cancelReason, setCancelReason] = createSignal<string | null>(null);
  const [loading, setLoading] = createSignal(false);

  const handleCancel = async () => {
    setLoading(true);
    try {
      await apiClient.post(
        '/LoadSure/CancelInsurance',
        {
          reasonCode: cancelReason(),
          loadId: loadId(),
          vendorContractId: loadSureVendorContractId(),
        },
        buildChangeTrackingRequestConfig([
          CHANGE_TRACKING_SOURCES.orderDetails.loadDetailsInsurance,
        ]),
      );
      const vendorIndex = orderStore.order.vendors?.findIndex(
        (v) => v.id === loadSureVendorContractId(),
      );
      setOrderStore(
        'order',
        'loads',
        orderStore.activeTab.index,
        'loadSureVendorContractId',
        null,
      );
      setOrderStore(
        'order',
        'vendors',
        produce((vendors) => {
          if (vendorIndex !== undefined && vendorIndex >= 0) {
            vendors?.splice(vendorIndex, 1);
          }
        }),
      );
      setLoadSureStore('isDirty', []);
      setOrderStore(
        'order',
        'loads',
        orderStore.activeTab.index,
        'loadSureCertificate',
        null,
      );
      setActiveCarrierTab({ index: 0, type: 'load' } as TabState);
      handleToast(ToastType.Success, 'Insurance cancelled successfully');
    } catch (error: unknown) {
      if (Array.isArray(error)) {
        error.forEach((err) => {
          handleToast(
            ToastType.Error,
            (err as { errorMessage: string }).errorMessage,
          );
        });
      } else {
        handleToast(ToastType.Error, 'Failed to cancel insurance');
      }
    } finally {
      setLoading(false);
      closeModal(cancelInsuranceModal);
    }
  };

  return (
    <div>
      <div class="text-xl font-semibold mb-2">Confirm Policy Cancellation</div>
      <div class="my-4 ">
        <LoadSureSelect
          label="Reason for Cancellation"
          value={null}
          onChange={(e: { target: { value: string } }) => {
            setCancelReason(e.target.value);
          }}
          required={true}
          options={cancelReasons.map((c) => ({
            id: c.id,
            name: c.name,
          }))}
        />
        <div class="flex gap-x-2 float-right mt-4">
          <Button
            onClick={handleCancel}
            variant="contained"
            color="info"
            endIcon={loading() ? <CircularProgress size={20} /> : null}
            disabled={cancelReason() === null}
            dataTestId="submit-cancel-insurance-button"
          >
            Submit
          </Button>
          <Button
            color="info"
            onClick={() => {
              closeModal(cancelInsuranceModal);
            }}
            dataTestId="cancel-cancel-insurance-button"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
